import React, { useState } from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import MetricsTable from './MetricsTable/index';
import { history, connect, useIntl } from 'umi';
import DigitalRevenue from './DigitalRevenue';
import PhysicalRevenue from './PhysicalRevenue';
import MAU from './MAU';
import Upcoming from './Upcoming';
import NewRelease from './NewRelease';
import LifetimePlayers from './LifetimePlayers';
import '@/pages/intelligence/assets/scss/TopCharts/ConsoleGames/index.scss';
// Famitsu/Japan Sales is temporarily unavailable; keep the page module for rollback.
// import JapanSales from './JapanSales';
import { DBI_TOPCHARTS } from '@/pages/intelligence/models/topcharts';
const { Body, Sider, Content } = Layout;

function ConsoleGames(props: any) {
  const { dispatch } = props;
  const [activeId, setActiveId] = useState(
    props?.match?.params?.tab || 'MetricsTable',
  );
  const [bodyLoading, setBodyLoading] = useState(false);

  const { formatMessage } = useIntl(); // 中英切换方法

  const tabs = [
    {
      id: 'MetricsTable',
      label: formatMessage({ id: `dbi_metrics_table` }),
      component: <MetricsTable />,
    },
    {
      id: 'DigitalRevenue',
      label: formatMessage({ id: `dbi_digital_revenue` }),
      component: <DigitalRevenue />,
    },
    {
      id: 'PhysicalRevenue',
      label: formatMessage({ id: `dbi_physical_revenue` }),
      component: <PhysicalRevenue />,
    },
    // Famitsu/Japan Sales is temporarily unavailable.
    // {
    //   id: 'JapanSales',
    //   label: (
    //     <div className="dbi-tab-flex">
    //       {formatMessage({ id: `dbi_japan_sales` })}
    //       {/* <span className="dbi-tab-new">NEW</span> */}
    //     </div>
    //   ),
    //   component: <JapanSales />,
    // },
    { id: 'MAU', label: formatMessage({ id: `dbi_mau` }), component: <MAU /> },
    {
      id: 'LifeTimePlayers',
      label: formatMessage({ id: `dbi_lifetime_players` }),
      component: <LifetimePlayers />,
    },
    {
      id: 'NewRelease',
      label: formatMessage({ id: `dbi_new_release` }),
      component: <NewRelease />,
    },
    {
      id: 'Upcoming',
      label: formatMessage({ id: `dbi_upcoming` }),
      component: <Upcoming />,
    },
  ];

  return (
    <Content>
      <Content.Header
        title={formatMessage({ id: `dbi_console_games` })}
        className="contentHead-normal"
      >
        <div className="header-tab">
          <Tabs
            ceiling
            newMarkIdsMappingKey="TopChartsConsoleGames"
            tabs={tabs}
            animated={false}
            activeId={activeId}
            onActive={(tab) => {
              setActiveId(tab.id);
              dispatch({
                type: `${DBI_TOPCHARTS}/setMetricValue`,
                payload: '',
              });
              dispatch({
                type: `${DBI_TOPCHARTS}/setMetricCurName`,
                payload: '',
              });
              history.replace(`/intelligence/topCharts/consoleGames/${tab.id}`);
              setBodyLoading(true);
              setTimeout(() => {
                setBodyLoading(false);
              }, 0);
            }}
          />
        </div>
      </Content.Header>
      <Content.Body full>
        {bodyLoading
          ? null
          : tabs.map((e) => {
              return (
                <div key={e.id}>{e.id == activeId ? e.component : ''}</div>
              );
            })}
      </Content.Body>
    </Content>
  );
}

export default connect((state: any) => {
  return {
    topchartsState: state[DBI_TOPCHARTS],
  };
})(ConsoleGames);
